/* eslint-disable max-lines */
export default {
  language: {
    en: 'English',
    es: 'Spanish'
  },
  title: {
    home: 'Home',
    dashboard: 'Dashboard',
    kpi: 'KPI',
    errorRisks: 'Error passing the risks',
    operations: 'Operations',
    operationsB2C: 'Operations_B2C',
    operationsB2B: 'Operations_B2B',
    operationsListB2C: 'List B2C',
    operationsListB2B: 'List B2B',
    expiration: 'Expiration',
    popupstore: 'Pop Up Store',
    showroom: 'Showroom',
    garage: 'Garage',
    addPartner: 'Add Partner',
    garageCampaigns: 'List',
    error404: 'Not found',
    error500: 'Error',
    accessDenied: 'Access Denied',
    newRequest: 'New  Request',
    campaignDetail: 'Campaign Detail',
    operationDetailB2C: 'Operation Detail B2C',
    operationDetailB2B: 'Operation Detail B2B',
    oidcCallback: 'Waiting...',
    newCampaign: 'New Campaign',
    editCampaign: 'Edit Campaña',
    cloneCampaign: 'Clone Campaña',
    importantInformation: 'Important information',
    productInformation: 'Product information',
    technicalDetails: 'Technical details',
    advancedEditCampaign: 'Advanced Edit Campaña',
    campaigns: 'Campaigns',
    cms: 'CMS',
    editMultipleCampaigns: 'Multiple campaigns edition',
    sortCampaigns: 'Sort campaigns',
    sortCampaignText: 'You need to select a partner to activate this button'
  },
  menu: {
    dashboard: 'Dashboard',
    kpi: 'KPI',
    operations: 'Operations',
    lists: 'Lists',
    operationsListB2C: 'List B2C',
    operationsListB2B: 'List B2B',
    expiration: 'Expiration',
    popupstore: 'Pop Up Store',
    showroom: 'Showroom',
    garage: 'Garage',
    addPartner: 'Partner',
    garageCampaigns: 'Campaigns',
    cms: 'CMS'
  },
  header: {
    account: {
      profile: 'Profile',
      settings: 'Settings',
      logout: 'Logout'
    }
  },
  message: {
    error: {
      notFound1: "Oops! You're lost.",
      notFound2: 'The page you are looking for was not found.',
      page500Text1: 'Houston, we have a problem!',
      page500Text2: 'The page you are looking for is temporarily unavailable.',
      accessDeniedText: 'Access Denied',
      accessDeniedReturn: 'Return to home page',
      oidcLoginError: 'Something went wrong at the start of the session!',
      fileTypeMismatch: 'We only support {accept} pictures.',
      fileSizeExceed: 'Please upload a picture smaller than {size}.',
      fieldRequired: 'The {field} field is required.',
      operationNotInterested:
        'The request for status not interested could not be carried out, try again.',
      operationCancel: 'The cancellation request could not be carried out, try again.',
      operationResendEmail: 'The resend email request could not be carried out, try again.',
      reserveNewCampaign: 'Reserve must be minor or equals than car stock',
      errorDateFromNewCampaign: 'The date from must be greater than or equal to today',
      errorDateToNewCampaign: 'The date even has to be greater than or equal to the date from',
      errorTermKmsMatrix: 'You must select at least a combination of term and mileage',
      errorCampaignNotExist: 'The requested campaign does not exist',
      updateCampaign: 'The request for update could not be carried out, try again.',
      updateMultipleCampaigns: 'Could not update any of the selected campaigns, please try again.',
      publishOmega: 'The request for Omega publication could not be carried out, try again.',
      unsubscribeCampaign:
        'The request for unsubscribe campaign could not be carried out, try again.',
      unpublishCampaign: 'The request for unpublish campaign could not be carried out, try again.',
      errorEditCampaignField: 'The field can not be modified',
      createNewNode: 'The creation of the new node could not be carried out, try again.',
      deleteNode: 'The node was not deleted successfully.',
      updateNode: 'The node was not updated successfully.',
      deleleNodeModal:
        'The name of the node inserted do not match with the current node to delete, try again.',
      operationResendSignature: 'The resend signature request could not be carried out, try again.',
      saveMassiveImages: 'Updated error massive images',
      saveMultipleImages: 'Error updating images in one or more of the selected campaigns',
      saveImages: 'Error updating images',
      getBrands: 'Error get brands',
      getModels: 'Error get models',
      getVersions: 'Error get versions',
      getVehicles: 'Error get vehicle',
      genericImagesBenchFilters: 'Error obtaining the data necessary to continue',
      errorPartnertitle: 'Partner Error',
      errorPartnerMessage: 'Contact a sales representative',
      listIdVehicles: 'Error get vehicle id'
    },
    warning: {
      updateMultipleCampaigns: 'The following campaigns have not been updated successfully',
      selectNode: 'Select a node: partner, template, or pattern.',
      createNode: 'Complete the fields to create a new node.',
      deleteNode: 'Select a node: template, pattern or element.',
      minImages: `You must upload at least {minImages} images.`,
      galleryUpdateCampaign:
        'The changes could not be saved, please check the images section and try again.'
    },
    success: {
      operationNotInterested: 'Request for status not interested successfully.',
      operationCancel: 'Request canceled successfully.',
      operationResendEmail: 'Request resesend email successfully',
      operationCreatedSuccess: 'Request successfully',
      updateCampaign: 'The request for update successfully.',
      updateMultipleCampaigns: 'All selected campaigns have been successfully updated',
      publishOmega: 'The request for Omega publication is successfully.',
      unsubscribeCampaign: 'The request for unsubscribe campaign is successfully.',
      unpublishCampaign: 'The request for unpublish campaign is successfully.',
      createNewNode: 'The node was created successfully.',
      deleteNode: 'The node was deleted successfully.',
      updateNode: 'The node was updated successfully.',
      operationResendSignature: 'The resend signature request is successfully.',
      saveImages: 'Save images successful'
    },
    question: {
      toDo: 'What would you like to do?'
    },
    generic: {
      checkAccess: 'Verifying access',
      loadingData: 'Loading data',
      poweredBy: 'Powered by',
      operationId: 'Operation Id: ',
      generatedOffer: 'generated offer: ',
      total: 'Total',
      edited: 'Edited',
      removeCampaignsToEdit:
        'You can remove from this list those campaigns that you do not want to edit',
      oneCampaignToEdit: 'At least one campaign must exist to edit your information',
      textRiskModal: 'Passing risks, please wait...',
      textCreateOperationModal: 'Creating the operation, please wait...',
      loadingTextModal: 'Processing information, wait please...',
      getImages: 'Get images',
      saveImages: 'Save imágenes'
    }
  },
  ui: {
    button: {
      btnBack: 'Back',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
      btnSaveChange: 'Save Changes',
      btnLoadAll: 'Load all',
      btnLoadPriority: 'Load priority',
      btnClose: 'Close',
      btnCreate: 'Create',
      btnConfirm: 'Confirm',
      btnChange: 'Change',
      btnDelete: 'Delete',
      btnNewRequest: 'New request',
      btnCampaignDetail: 'Campaign detail',
      btnRecord: 'Save',
      btnClear: 'Clear',
      btnNotInterested: 'No interesado',
      btnResendMail: 'Reenviar mail',
      btnAddAttorney: 'Add new Attorney',
      btnRemoveAttorney: 'Remove attorney',
      btnExport: 'Export',
      btnContinue: 'Continue',
      btnLoading: 'Loading...',
      btnContract: 'Contract',
      btnMoreInfo: 'More info',
      btnSend: 'Send',
      btnSavePartner: 'Save partner',
      btnChooseImage: 'Choose an image',
      btnRemoveImage: 'Remove image',
      btnSelectAll: 'Select All',
      btnUnSelectAll: 'Unselect All',
      btnShowroom: 'Show in showroom',
      btnCancelOperation: 'Cancel operation',
      btnReloadRegisters: 'Reload records',
      btnTesla: 'See operations in "Tesla" ',
      btnCreateCampaign: 'Create Campaign',
      btnNewCampaign: 'New Campaign',
      btnRetrieveOffer: 'Retrieve offer',
      btnToday: 'Today',
      btnThreeMonths: '+3m',
      btnMoreOptions: 'More options',
      btnAccessoriesSelectAll: 'Select all',
      btnAccessoriesUnSelectAll: 'Unselect all',
      btnAccessoriesShowSelected: 'Show selected',
      btnAccessoriesShowAll: 'Show all',
      btnCopy: 'Copy',
      btnCopyAll: 'Copy all',
      btnPreviewCampaign: 'Preview campaign',
      btnMoreFilters: 'More filters',
      btnAdvancedEdit: 'Advanced edit',
      btnSetToManualStudy: 'Set to manual study',
      btnReservedQuotes: 'Clean offer',
      sortCampaigns: 'Sort campaigns',
      btnResendSignature: 'Resend to signature',
      btnResetFilters: 'Delete filters',
      btnGetImages: 'Get images',
      btnSaveImages: 'Save images'
    },
    badge: {
      campaignFactory: 'FACTORY ORDER',
      inStockAvailable: 'In Stock',
      arrivalDateExpected: 'Fh. Prev. llegada'
    },
    label: {
      searchInput: 'Search',
      searchInputPlaceHolder: 'Insert search text',
      color: 'Color',
      checkRememberMe: 'Remember me',
      checkConfirmTerms:
        'I confirm that I have communicated to the interested party the conditions of the offer and I have collected the consent to provide the personal data in order to make the offer.',
      month: 'Month',
      months: 'Months',
      doors: 'Doors',
      accessories: 'Accessories',
      limit: 'Limit',
      kms: 'Kms',
      yearKmsText: 'Annual Kms',
      extraKmsText: 'Extra Kms',
      refundKmsText: 'Refund Kms',
      yearKmsUnit: 'kms/year',
      initialContribution: 'Initial Contribution',
      partner: 'Partner',
      type: 'Type:',
      optionIncluded: 'Included options:',
      equipment: 'Equipment',
      servicesIncluded: 'Included services:',
      settingsIncluded: 'Mileage settings:',
      newRequestTitle: 'Fill in the required data',
      newRequestSubTitle1: "Prepare the prospect's documentation to make it faster for you.",
      newRequestSubTitle2: 'Start now!',
      garageCampaignsTitle: 'Campaign manager',
      sortCampaignsTitle: 'Sort campaigns',
      sortCampaignInfo:
        '* The campaigns that are in color are the ones that are ordered according to their status.',
      sortCampaignInfo2:
        '* If you move the campaigns, remember to click on the Save changes button',
      operationsListB2C: 'Operations list B2C',
      operationsListB2B: 'Operations list B2B',
      operationsExpiration: 'Espiration operations',
      company: 'Company',
      checkOperation: 'Check to pass the operation on behalf of a company',
      operationDetailTitle: 'Detail operation',
      reference: 'Reference',
      copyDataContact: 'Check if the data matches that of the contact',
      operationId: 'Operation Id',
      agent: 'Agent',
      dischargeDate: 'Discharge Date',
      updateDate: 'Update Date',
      deliveryDate: 'Delivery date',
      riskStatus: 'Risk status',
      operationStatus: 'Operation status',
      signatureStatus: 'Signature status',
      function: 'Function',
      identificationDocument: 'Identification Document',
      name: 'Name',
      email: 'E-mail',
      phone: 'Phone',
      mobile: 'Mobile',
      address: 'Address',
      postalCode: 'Postal Code',
      city: 'City',
      province: 'Province',
      businessName: 'Business Name',
      cif: 'CIF',
      companyData: 'Datos de la empresa',
      companyName: 'Business name',
      constitutionDate: 'Constitution Date',
      fax: 'Fax',
      registeredOffice: 'Registered Office',
      signType: 'Sign Type',
      titleLogin: 'Login',
      subTitleLogin: 'Enter your login hint',
      loginDescription:
        'To access you must be registered as a partner. For any questions, contact your commercial advisor.',
      originCampaign: 'Origin',
      partnerName: 'Partner Name',
      partnerNameLOPD: 'Partner LOPD Name',
      partnerNameLOPDEmail: 'Partner Email Contact',
      partnerAssociatedCommercial: 'Associated Commercial',
      partnerTheme: 'Theme',
      partnerLOPD: 'Legal Text LOPD',
      partnerLOPDWeb: 'Legal Text WEB SOLVENCIA',
      partnerLogos: 'Partner Logos',
      partnerLogosFooter: 'Footer Logos',
      partnerIdLleida: 'Id Sign Lleida',
      partnerAppVersion: 'Application Version',
      themeName: 'Theme Name',
      themePrimaryColor: 'Primary Color',
      themeSecondaryColor: 'Secondary Color',
      iva: 'IVA',
      newCampaignTitle: 'Please, insert new name for cloned campaign',
      markdownTitleContents: 'Contents',
      markdownTitlePreview: 'Preview',
      campaignName: 'Campaign name',
      channel: 'Channel',
      id: 'Id',
      dateCampaignActive: 'Dates active campaign',
      groupCampaigns: 'Campaigns group',
      contract: 'Contract',
      services: 'Services',
      contractTextTermConditions: 'Text Term Conditions',
      textSecure: 'Text Secure',
      textSelfDamage: 'Text Self Damages',
      contractTextWarranty: 'Warranty',
      firstDebitDueDate: 'Debit due date contract',
      warrantyFeeDescription: 'At the signing of the contract:',
      warrantyFeeDescriptionTitle: 'Warranty fee',
      nonPaymentCompensation: 'Non payment compensation',
      contractTextDebitReturnFee: 'Debit return fee',
      tableServicesPostSubtotal: 'Repair Self Dagames',
      renter: 'Renter',
      renterName: 'Name',
      renterLegalRepresentative: 'Legal Representative',
      renterAddress: 'Address',
      renterPostalCode: 'Postal Code',
      renterEmail: 'Email',
      renterCompanyName: 'Company Name',
      renterLegalRepresentativeDocumentId: 'DNI',
      renterAddressCity: 'City',
      renterPhone: 'Phone',
      renterBillingEmail: 'Billin Email',
      renterDocumentId: 'CIF',
      renterAddressProvince: 'Province',
      renterCustomerCareEmail: 'Customer Care',
      renterCustomerCarePhone: 'Customer Care Phone',
      renterSignature: 'Signature',
      manualSignatureInstructions: 'Manual signature instructions',
      contractTextDocumentsIncluded: 'Text Document includes in contract',
      signatureDig: 'Electrónica',
      signatureMan: 'Manual',
      contractTemplateName: 'Contract Template Name',
      contractVersion: 'Contract Version',
      contractName: 'Contract Name',
      contractId: 'ID Contract',
      contractEmailSupport: 'Support Email',
      partnerLogoLeft: 'Left logo',
      partnerLogoRight: 'Right logo',
      tooltipTitleGallery: 'Open cloud directory',
      addCustomersAssociated: 'Add customers',
      campaignCustomersAssociated: 'Campaign customers associated',
      customersList: 'Customers list',
      dragCustomersHere: 'Drag and drop customers',
      search: 'Search',
      risk: 'Risk',
      state: 'State',
      operation: 'Operation',
      contractLogoLeft: 'Logo Left',
      contractLogoRight: 'Logo Right',
      addNewContractTextDocument: 'Add Document',
      typeVehicle: 'Offer type',
      typeModality: 'Modalidad',
      bodyStyle: 'Body Style',
      rangePrice: 'Range price',
      all: 'All',
      new: 'New',
      used: 'Used',
      sale: 'Sale',
      km0: 'Km0',
      km: 'Km',
      registrationYear: 'Registration Year',
      selected: 'Selected',
      ctrlclick: 'CTRL + Clic to select separate items',
      summary: 'Summary',
      summary_contact: 'summary-contact',
      concession: 'Concession',
      selectCustomer: 'Indicates the clients associated with the new campaign',
      reservationOfferNumber: 'Reservation offer number',
      selectPartner: 'Select Partner',
      filter: 'Find',
      ubication: 'Ubication',
      publishedIn: 'Published in: ',
      settingsKms: 'Mileage adjustment: ',
      card: 'Card',
      detail: 'Details',
      activecampaigns: 'Active campaigns',
      stockvehicles: 'Vehicles in stock',
      globalStatus: 'State of risk',
      order: 'Order',
      internalOrder: 'Internal order',
      offer: 'Offer',
      offerId: 'Offer Id',
      term: 'Term',
      campaign: 'Campaign',
      partnersList: 'Partners list',
      offerCamp: 'Mother offer',
      availableStock: 'Available Stock',
      campaignDates: 'Campaign Dates',
      reserveInfo: 'Reserve available stock?',
      messageStockZero: 'Insert 0 for campaign without reservation',
      reserve: 'Reserve',
      reserveCars: 'cars',
      reserveCar: 'car',
      from: 'From',
      to: 'To',
      termKms: 'Term/Kms',
      selectContractTemplate: 'Select Contract Template',
      hasClients: 'Has Concessions/Clients?',
      commercialSedan: 'Commercial sedan',
      gateSedan: 'Sedan with gate',
      frontisCab: 'Frontis cab',
      platformCab: 'Platform cab',
      cabrio: 'Cabrio',
      openBox: 'Open box',
      truck: 'Truck',
      movingVan: 'Moving van',
      cabChassis: 'Cab chassis',
      doubleCabChassis: 'Double cab chassis',
      frontisChassis: 'Frontis chassis',
      combi: 'Combi',
      commercial: 'Commercial',
      coupe: 'Coupe',
      familiar: 'Familiar',
      passengerVanDerivatives: 'Passenger van derivatives',
      van: 'Van',
      glazedVan: 'Glazed van',
      miniBus: 'Mini bus',
      miniCar: 'Minicar',
      miniVan: 'Minivan',
      compactMinivan: 'Compact minivan',
      pickup: 'Pickup',
      pickupDerivatives: 'Pickup derivatives',
      sedan: 'Sedan',
      targa: 'Targa',
      allTerrainCommercial: 'All-terrain commercial',
      allTerrain: 'All-terrain',
      caravanVehicle: 'Caravan vehicle',
      tipper: 'Tipper',
      included: 'Included',
      notIncluded: 'Not included',
      notIncorporated: 'Not incorporated',
      vehicleStatus: 'Status',
      brand: 'Brand',
      modelName: 'Model',
      configuration: 'Configuration',
      engineType: 'Engine type',
      bulletPoints: 'Bullet points',
      bulletPoint: 'Bullet points',
      multimediaFunctionality: 'Multimedia systems',
      specialFeatures: 'Special features',
      acceleration: 'Acceleration',
      colorName: 'Color name',
      colorMap: 'Color map',
      driveSystem: 'Drive system',
      fuelCapacity: 'Fuel capacity',
      fuelEconomyCity: 'Fuel economy city',
      fuelEconomyHighway: 'Fuel economy highway',
      fuelEconomyCombined: 'Fuel economy combined',
      interiorColor: 'Interior color',
      interiorColorName: 'Interior color name',
      transmissionType: 'Transmission type',
      genericKeywords: 'Generic keywords',
      car: 'Car',
      stockAvailable: 'Stock',
      publishDraft: 'Publish in draft',
      campaignForPublish: 'Campaign for publish',
      price: 'Price',
      motorization: 'Motorization',
      finished: 'Finished',
      legalNote: 'Legal note',
      interior: 'Interior',
      version: 'Motor type',
      vehicleVersion: 'Version',
      numberOfDoors: 'No. of Doors',
      maximumCompatibleNumberSeats: 'Max. Compatible Number Seats',
      modelYearRange: 'Range Year Model',
      kilometers: 'Kilometers',
      fuelType: 'Fuel Type',
      storageVolume: 'Storage Volume',
      tireType: 'Tire Type',
      maximumHorsepower: 'Max. Horsepower (cv)',
      maximumOutputPower: 'Nax. OutputPower (kW)',
      engineDisplacement: 'Engine Displacement',
      maximumSpeed: 'Maximum Speed',
      itemWeight: 'Item Weight',
      environmentalDescription: 'Environmental Description',
      itemWidth: 'Item Width',
      itemHeight: 'Item Height',
      includedFeatures: 'Included Features',
      exitFromEdit: '¿There are any changes, ¿really want exit?',
      euEnergyLabelEfficiencyClass: 'Energy label efficiency class',
      single: 'Single',
      addBulletPoint: 'Add bullet point',
      content: 'Content',
      preview: 'Preview',
      description: 'Description',
      driverLicense: 'Driver license',
      renovation: 'Renovation',
      renovationExplanation: ' (in case you have a car with Ayvens that you are going to return)',
      firstRegistrationDate: 'First registration date',
      salePrices: 'Sale price',
      title: 'Title',
      deleteNode: 'Are you sure you want to delete the node',
      insertCurrentNodeName: 'Please, insert the node name you want to delete:',
      selectMultiple: 'Multiple selection',
      reportExpertise: 'See expert report',
      campaignsToEdit: 'Campaigns tod edit:',
      selectPartnerWarning: 'You need to select a partner to activate this button',
      reserved: 'Reserved',
      reservedNotContract: 'It cannot be hired because it is reserved',
      descriptionCosmos: 'Description',
      reserveAllStockInformation:
        '*As select this option, will be reserved all avaiable vehicles from the down purchase offer campaign.',
      flow: 'Flow',
      templateType: 'Template type',
      customerName: 'Customer Name',
      selectAll: 'Select all',
      zone: 'Zone',
      vehicle: 'Vehicle',
      idVehicle: 'ID Vehicle'
    },
    select: {
      noResult: 'Sorry, no matching result',
      noResultPartner: 'Sorry, no matching partners',
      labelNew: 'new',
      active: 'Active',
      noActive: 'No active',
      all: 'All'
    },
    name: {
      checkConfirmTerms: 'Confirm communication of conditions',
      color: 'Color'
    },
    placeholder: {
      genre: 'Gender',
      profession: 'Profession',
      birthDate: 'Borth Date',
      maritalStatus: 'Marital Status',
      email: 'Email',
      mobilePhone: 'Mobile Phone',
      streetType: 'Street Type',
      address: 'Address',
      postCode: 'Post Code',
      town: 'Town',
      name: 'Name',
      surname: 'Surname',
      surname2: 'Second surname',
      documentTypes: 'Document Type',
      documentId: 'Document Number (DNI, NIE)',
      selectPartner: 'Please select an partner',
      selectPartnerNameOrId: 'Search by Partner Name or Id',
      userName: 'Username',
      newCampaignName: 'New campaign name Ex {campaignName} 15K',
      partnerLogoImg: 'Leave your PNG here',
      partnerLogoImgDescription:
        'The logo must have a transparent background and a maximum height of 40px',
      customerName: 'Customer Name',
      addReservation: 'Add reservation and press Enter',
      selectContractTemplate: 'Select Contract Template',
      select: 'Select {field}',
      newKeyword: 'Insert new keyword',
      issueDate: 'Issue of date',
      insuranceType: 'Insurance type',
      operationOwner: 'Operation of',
      insuranceMonthFee: 'Monthly insurance amount',
      marketPlaceOrderId: 'Internal reference'
    },
    table: {
      filterPlaceholder: 'Please enter your search query',
      perPage: 'per page',
      noResults: 'There are no records to show',
      noResultsFiltered: 'There are no records matching your request',
      count: 'Showing from {from} to {to} of {count} records',
      countFiltered: 'Showing from {from} to {to} {visibility} of {count} filtered records',
      countPossible: 'Showing from {from} to {to} {visibility} of {count} possible records',
      countRecords: 'Showing {count} records',
      countCards: 'Showing {count} records of {total} possible',
      active: 'active records',
      noActive: 'no active records',
      loading: 'Loading data...',
      dblclickedDetailTitle: 'Double click to see the detail',
      fields: {
        campaignName: 'Campaign',
        actions: 'Actions',
        id: 'Id',
        updated: 'Updated',
        photo: 'Photo',
        partner: 'Partner',
        origin: 'Origin',
        group: 'Group',
        to: 'To',
        invisibility: 'Invisibility',
        version: 'vX',
        reference: 'Reference',
        signUp: 'SignUp',
        state: 'State',
        riskStatus: 'Risk Status',
        documentation: 'Documentation',
        sign: 'Sign',
        identification: 'Identification',
        email: 'Email',
        user: 'User',
        concession: 'Concession',
        document: 'DNI/NIE',
        updateDate: 'Update Date',
        expirationDate: 'Expiration Date',
        monthFee: 'Month Fee',
        model: 'Model',
        accessories: 'Accessories',
        limit: 'Limit',
        yearKms: 'Year kms',
        downPayment: 'Down Payment',
        order: 'Order',
        internalOrderStatus: 'Internal order',
        vehicle: 'Vehicle',
        process: 'Process',
        offerCamp: 'OferrCamp',
        offerClient: 'OferrClient',
        createDate: 'Create Date',
        custodyDate: 'Custody Date',
        availableDate: 'Available Date',
        pickupDate: 'Pickup Date',
        equipment: 'Equipment',
        marketplacePublication: 'Marketplace',
        stockAvailable: 'Stock',
        accessoryId: 'Id',
        accessoryDescription: 'Descripción',
        accessoryIncludedFeatures: 'Included features',
        accessoryMultimedia: 'Multimedia features',
        accessorySpecial: 'Special features',
        plateNumber: 'Plate number',
        campaignType: 'Campaign type'
      },
      menuCampaign: {
        new: 'Clone to new campaign',
        duplicate: 'Duplicate and unsubscribe',
        unsubscribe: 'Unsubscribe',
        publish: 'Publish in Marketplace',
        edit: 'Edit campaign',
        publishOmega: 'Publish at Omega',
        unpublish: 'Unpublish'
      }
    },
    modal: {
      confirmRequestTitle: 'Operation executed successfully',
      titleConfirmDelete: 'Delete record',
      contentConfirmDelete: 'Do you want to delete the record "{record}"?',
      cloneAndNewCampaignTitle: 'You will create a campaign from an old',
      cloneAndUnsubscribeCampaignTitle: 'You will clone a campaign and unsubscribe old',
      unsubscribeCampaignTitle: 'You will unsubscribe campaign',
      unpublishCampaignTitle: 'You will unpublish campaign',
      publishOmegaTitle: 'You will publish campaign in Omega',
      campaignId: 'Campaign id',
      oldCampaignId: 'Older campaign Id',
      newCampaignId: 'NEW Nº campaign',
      toDateInvisibility: 'Invisibility date',
      btnOkNewRequest: 'Go to Showroom',
      btnCancelNewRequest: 'New Request',
      createNewThemeTitle: 'Create a new Theme',
      titleMarketplace: 'Publish in market',
      moveCAmapignTitle: 'Do you want to exit without saving?',
      moveCampaignMessage:
        'You have changed the order of the campaigns but you have not saved. Do you want to leave without saving the changes?',

      operation_not_to_disclose:
        'This operation can not be undone. Please confirm that you want to execute the action ',
      publishCampaignTitle: 'Publish campaign',
      exitTitle: 'Exit from edit campaign',
      modalityTitle: 'Choose a modality',
      modalitySingle: '',
      modalityFamiliar: '',
      createCampaign: 'Create campaign',
      createCampaignError: 'Error when creating campaign',
      retrieveCampaignError: 'Error when retrieving campaign',
      existingOperation: 'Existing operation',
      invalidOperation: 'Invalid operation',
      deleteNode: 'Delete node',
      unpublishFromMarketplce: 'Unpublish from marketplace',
      releaseVehicle: 'Insert number of vehicles to release',
      releaseVehicleStock: 'Available stock : ',
      releaseVehicleNotAvailable: 'Not available vehicules',
      releaseVehicleTitle: 'Liberate vehicle',
      errorOcurred: 'Unexpected error has occurred',
      reservedQuotesTitle: 'Notice',
      reservedQuotesText:
        'The offer has already been used in a previous post. Do you want to clean the family of offers?',
      operationExist: 'Operation already exist',
      templatesEmptyTitle: 'Error when uploading templates',
      templatesEmptyText:
        'Cannot create campaign due to template loading problem, please try again later.'
    },
    notify: {
      successDelete: 'The "{record}" record was successfully deleted',
      errorDelete: 'An error occurred while trying to delete the "{record}" record',
      successAddPartner: 'New Partner created successfully'
    },
    tab: {
      general: 'General',
      car: 'Car',
      accessories: 'Accessories',
      images: 'Images',
      contract: 'Contract',
      risk: 'Risk',
      clients: 'Clients',
      filter: 'Filter',
      extendedFilters: 'Extended filters'
    }
  },
  legal: {
    showroom:
      'IVA INCLUIDO en los importes. La fotografía puede no coincidir con la versión / accesorios ofertados. Válida para Península y Baleares. Válida hasta fin de existencias de la campaña.'
  }
};
